// extracted by mini-css-extract-plugin
export default {"columnSort":"RequestDeals_columnSort__KM1bD","buttonWrapper":"RequestDeals_buttonWrapper__FVay9","button":"RequestDeals_button__ts2BQ"};